module.exports = __webpack_public_path__ + "static/media/YB5M09_1.b26b7350.jpg";